export default __webpack_public_path__ + "static/media/shangpin_s.b3009a15.png";